export const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/';
export const POSTER_SIZE = "w780";
export const BACKDROP_SIZE = 'w780';
export const DEFAULT_POSTER = 'https://via.placeholder.com/500x750?text=No+Image+Available';